import {
  ComplianceTransferRow,
  TransactionStats,
  TransactionStatsResponse,
  TxListResponse,
} from '@/api';
import { getFormattedDateWithTime } from '@/helpers';

const fetchTransfers = (response: TxListResponse) => {
  const {
    data: { items, total },
  } = response;

  let txs: ComplianceTransferRow[] = [];

  if (Array.isArray(items) && items.length) {
    txs = items.map((item) => {
      return {
        key: item.id,
        customer: item.customer,
        user: item.customer[0].name || item.customer[0].identifier || '',
        txHash: item.hash,
        address: item.address,
        counterparty: item.counterparty,
        direction: item.direction,
        level: item.level,
        fundsTransferred: Number(item.amount) / 100,
        nextUpdate: getFormattedDateWithTime(item.nextUpdateTs),
      };
    });
  }
  return { txs, total };
};

const fetchTransferStats = (response: TransactionStatsResponse) => {
  const { data } = response;

  const statsData: TransactionStats = {
    total: data.total / 100,
    income: data.income / 100,
    outcome: data.outcome / 100,
    count: data.count,
  };

  return statsData;
};

export { fetchTransfers, fetchTransferStats };
